import Ajax from './ajax';
// 登录
export default {
  POSTconfirmLogin (param) {
    return Ajax.post(`/api/grade/v1/app/confirm/login`, { ...param })
  },
  GETsendVcode (param) {
    return Ajax.get(`/api/grade/v1/app/vcode`, { ...param })
  },
  POSTloginByVcode (param) {
    return Ajax.post(`/api/grade/v1/app/login`, { ...param })
  },
  POSTloginByPass (param) {
    return Ajax.post(`/api/grade/v1/app/loginByPass`, { ...param })
  },
  POSTresetPass (param) {
    return Ajax.post(`/api/grade/v1/app/resetPass`, { ...param })
  },
  // 获取oem配置
  GETOemConfig(param) {
    return Ajax.get(`/api/grade/v1/app/oem/config`, param);
  },
  // 获取sessin
  postStartSession (param = {}) {
    return Ajax.post(`/api/grade/v1/app/startsession`, { ...param })
  },
  GETmonitorroom(param) {
    return Ajax.get(`/api/grade/v1/monitorroom`, param);
  },
  // 获取单个考生的信息
  GETstudentexam(param) {
    return Ajax.get(`/api/grade/v1/monitorroom/studentexam`, param);
  },
  // 获取小组的考生信息
  GETgradeteam(param) {
    return Ajax.get(`/api/grade/v1/monitorroom/gradeteam`, param);
  },
  // 获取科目元数据信息
  GETMonitorroomsubjectmeta(param) {
    return Ajax.get(`/api/grade/v1/monitorroom/exam/subjectmeta/${param.roundId}/${param.roomId}/${param.subjectId}`);
  },
  POSTMonitorroomFlag (param = {}) {
    return Ajax.post(`/api/grade/v1/monitorroom/student/flag`, { ...param })
  },
  // 获取考试信息
  GETMonitorroomExam (param = {}) {
    return Ajax.get(`/api/grade/v1/monitorroom/exam/${param.examSubjectId}`)
  },
  // 局域网轮训接口
  GETMonitorroomstatus (param = {}) {
    return Ajax.get(`/api/grade/v1/monitorroom/monitorroomstatus`, { ...param }, { showLoading: false })
  },
};
